<p-blockUI [blocked]="pageLoading()" />
<app-progress-spinner [enabled]="pageLoading()" />

<div class="header">
  <div class="switch">
    <label>{{ 'OPMONITORING.LABEL.SIGNED_OUT_VISITORS' | translate }}:</label>
    <p-toggleswitch
      name="showSignedOutVisitors"
      class="signed-out-switch"
      [(ngModel)]="showSignedOutVisitors"
      (onChange)="refresh()"
    />
  </div>
  <div>
    <button
      pButton
      class="refresh-button width-twenty"
      icon="fa fa-fw fa-refresh"
      (click)="refresh()"
    ></button>
  </div>
  <div>
    <button
      pButton
      label="{{ 'COMMON.LABEL.BUTTONS.CLEAR' | translate }}"
      icon="fa fa-fw fa-eraser"
      (click)="clearTable()"
    ></button>
  </div>
</div>

<app-general-grid
  [values]="elements"
  [columns]="columns"
  [totalRecords]="totalRecords"
  [filterable]="true"
  [screenName]="screenName"
  [rows]="rows"
  [lazy]="true"
  (lazyLoad)="lazyLoad($event)"
  [includeExportCSV]="false"
  scrollHeight="calc(100vh - 325px)"
  [usePaginator]="true"
  [rowsPerPageOptions]="[50, 100, 200]"
  #grid
/>
